/**
 * @fileoverview Text Editor Toolbar Component
 * 
 * Toolbar with formatting buttons for markdown editing
 */

import React from 'react';

/**
 * Text Editor Toolbar Component
 * 
 * @param {Object} props - Component props
 * @param {function} props.onBold - Bold formatting handler
 * @param {function} props.onItalic - Italic formatting handler
 * @param {function} props.onPreview - Preview toggle handler
 * @param {boolean} props.showPreview - Whether preview is currently shown
 * @param {boolean} props.disabled - Whether toolbar is disabled
 * @param {string} props.testId - Test ID
 */
const TextEditorToolbar = ({ 
  onBold, 
  onItalic, 
  onPreview, 
  showPreview, 
  disabled,
  testId 
}) => {
  return (
    <div className="text-editor-toolbar" data-testid={testId}>
      <div className="toolbar-group">
        <button
          type="button"
          onClick={onBold}
          disabled={disabled}
          className="toolbar-button bold-button"
          title="Bold (Ctrl+B)"
          data-testid={`${testId}-bold`}
        >
          <strong>B</strong>
        </button>
        
        <button
          type="button"
          onClick={onItalic}
          disabled={disabled}
          className="toolbar-button italic-button"
          title="Italic (Ctrl+I)"
          data-testid={`${testId}-italic`}
        >
          <em>I</em>
        </button>
      </div>

      <div className="toolbar-group">
        <button
          type="button"
          onClick={onPreview}
          disabled={disabled}
          className={`toolbar-button preview-button ${showPreview ? 'active' : ''}`}
          title="Toggle Preview (Ctrl+P)"
          data-testid={`${testId}-preview`}
        >
          {showPreview ? 'Edit' : 'Preview'}
        </button>
      </div>
    </div>
  );
};

export { TextEditorToolbar };